/** @format */

// Contains all the languages the editor has, the first one being the default
export const availableLanguages = ['fr', 'en'];
